// Internal modules
import { appStore } from '@/store';
import { apolloQuery } from '@/lib/apollo';
import { getLocale, getShippingCountry, getToken } from '@/lib';
import { CALCULATE_SHIPPING_AND_TAXES_QUERY } from '../queries/calculateShippingAndTaxes';
import { getShippingMethodsToStoreInState } from '../lenses/getShippingMethodsToStoreInState';
import { logMissingShippingMethodsToFPTI } from '../../fpti';

const calculateShippingAndTaxes = () => {
  const { form: formState } = appStore.getState();
  const { billingAddress, shippingAddress, shipToBilling } = formState;
  const { ui: uiActions } = appStore.getActions();
  const { setIsShippingShown } = uiActions;

  const { language: lang } = getLocale();
  const {
    line1: { value: line1 },
    line2: { value: line2 },
    city: { value: city },
    state: { value: state },
    postalCode: { value: postalCode },
  } = shipToBilling.value ? billingAddress : shippingAddress;

  const country = getShippingCountry();

  const variables = {
    locale: {
      country,
      lang,
    },
    // Country is the only required address fields, and we'll always have that
    // so we don't need any validation around address fields
    shippingAddress: {
      city,
      country,
      line1,
      line2,
      postalCode,
      state,
    },
    token: getToken(),
  };

  return apolloQuery({
    query: CALCULATE_SHIPPING_AND_TAXES_QUERY,
    variables,
  }).then(({ data }) => {
    const { ui: uiState } = appStore.getState();
    const { pageLevelError } = uiState;
    const { api: apiActions, ui: uiActions } = appStore.getActions();
    const { setCartData, setShippingOptionsSource } = apiActions;
    const { setPageLevelError } = uiActions;
    const {
      charges,
      shippingOptionsSource,
      isShippingRegionSupported,
    } = data.calculateShippingAndTaxes;
    const isShippingMethodAvailable = charges.length > 0;

    if (!isShippingRegionSupported) {
      setPageLevelError('pageLevelError.shippingRegionUnsupported');
    } else if (
      isShippingRegionSupported &&
      pageLevelError === 'pageLevelError.shippingRegionUnsupported'
    ) {
      // clear page level error if there is an error for
      // shippingRegionUnsupported
      setPageLevelError('');
    }

    if (!isShippingMethodAvailable) {
      logMissingShippingMethodsToFPTI();
      setIsShippingShown(false);
      return;
    }

    setCartData({
      shippingMethods: getShippingMethodsToStoreInState(charges),
    });
    setShippingOptionsSource(shippingOptionsSource);

    return data;
  });
};

export { calculateShippingAndTaxes };
